import $ from 'jquery'
import selectWrap from './selectWrap';

const initNewsletterForm = () => {
    var form = $('form[id*="newsletter"]');

    form.on('strutform-errors', (event,data) => {
        for(var n in data) {
            var ff = form.find('.formfield-' + n);
            if(ff.length) {
                var i = ff.find('input[type="text"],input[type="password"]');
                if(i.length) {
                    var d = $("<div class='error-icon'><i class='icon-close'></i></div>").prependTo(ff);
                }
            }
        }
    });

    form.find('input').on('focus blur',function() {
        var ff = $(this).closest('.formfield').removeClass('error');
        ff.find('.error-icon,.error-message').remove();
        ff.find('.error').removeClass('error');
    });

    selectWrap.init(form);
}

export default {
    init() {
        initNewsletterForm();
    }
}
